import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@utils';

export default function Text({ children, className, ...rest }) {
  if (!children) return null;

  return (
    <p
      className={mergeClasses(
        'm-0 text-base leading-normal text-black',
        className
      )}
      {...rest}
    >
      {children}
    </p>
  );
}

Text.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Text.defaultProps = {
  children: undefined,
  className: ''
};
